import React, { useEffect, useState } from 'react';
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <div className="sticky top-0 z-40 py-2.5 px-4 w-full" style={{
    backgroundColor: '#0F3C3C'
  }} data-id="element-14">
      <p className="text-white text-[13px] text-center font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-15">
        <span data-id="element-16">🔥 OFERTA DE LANZAMIENTO: 9,95€ (Antes 27€) · FINALIZA EN:</span>
        <span className="font-bold text-lg tracking-wider" style={{
        color: '#D4AF37'
      }} data-id="element-17">
          {minutes}:{seconds}
        </span>
      </p>
    </div>;
}